import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconLocked: React.FC = () => (
    <Icon viewBox="0 0 12 16" fill="none">
        <path
            d="M2.86667 6.6V4.26667C2.86667 3.40029 3.21083 2.5694 3.82345 1.95678C4.43607 1.34417 5.26696 1 6.13333 1C6.99971 1 7.8306 1.34417 8.44322 1.95678C9.05583 2.5694 9.4 3.40029 9.4 4.26667V6.6M6.13333 9.86667V11.7333M1.93333 6.6H10.3333C10.3333 6.6 11.2667 6.6 11.2667 7.53333V14.0667C11.2667 14.0667 11.2667 15 10.3333 15H1.93333C1.93333 15 1 15 1 14.0667V7.53333C1 7.53333 1 6.6 1.93333 6.6Z"
            stroke="currentColor"
            strokeWidth="0.933333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
